// Phase 15 Plan 09 Task 1 — TournamentHistoryAccordion.
//
// Native HTML `<details><summary>` element. Collapsed by default. Renders
// the last 3 past tournament cycles when available.
//
// IMPORTANT: the past-cycles endpoint is NOT yet exposed by the backend
// in Phase 15 (the per-tournament DO holds history but no list endpoint
// returns it). This component always renders the empty-state copy
// `social.tournaments.history.empty` for now. A future plan must add the
// past-cycles endpoint + thread it through the lobby payload or a
// dedicated /api/tournaments/history endpoint, then this component
// renders the cards.

import type { JSX } from 'react'
import { FormattedMessage } from 'react-intl'

export function TournamentHistoryAccordion(): JSX.Element {
  return (
    <details
      data-testid="tournament-history-accordion"
      className="card"
      style={{
        // Folk `.card` recipe owns the surface (borderless + warm shadow).
        width: '100%',
        maxWidth: '480px',
        padding: 'var(--space-4)',
      }}
    >
      <summary
        style={{
          cursor: 'pointer',
          fontFamily: 'var(--font-family-display)',
          fontWeight: 700,
          fontSize: 'var(--font-size-16)',
          color: 'var(--color-text-primary)',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}
      >
        <FormattedMessage
          id="social.tournaments.history.title"
          defaultMessage="Past tournaments"
        />
      </summary>
      <div
        style={{
          marginTop: 'var(--space-3)',
          padding: 'var(--space-3)',
          fontFamily: 'var(--font-family-body)',
          fontWeight: 500,
          fontSize: 'var(--font-size-14)',
          color: 'var(--color-text-tertiary)',
          lineHeight: 1.5,
        }}
      >
        <FormattedMessage
          id="social.tournaments.history.empty"
          defaultMessage="No past cycles yet."
        />
      </div>
    </details>
  )
}
